import * as React from 'react';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { cn } from "@/lib/utils";

interface DataTableSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

/**
 * DataTableSearch component for global search (e.g., by ID).
 *
 * When `placeholder` is a hardcoded "Search anything..." style string the
 * caller passes in we still respect it, but to make dozens of call-sites
 * automatically localise we also translate that canonical English string.
 */
const LEGACY_DEFAULT_PLACEHOLDERS = new Set([
  'Search anything...',
  'Search by ID...',
]);

export function DataTableSearch({
  value,
  onChange,
  placeholder,
  className,
}: DataTableSearchProps) {
  const { t } = useTranslation('common');
  const resolvedPlaceholder =
    !placeholder || LEGACY_DEFAULT_PLACEHOLDERS.has(placeholder)
      ? t('dataTable.searchAnything')
      : placeholder;

  return (
    <div className={cn('relative w-full', className)}>
      <Search className="text-muted-foreground absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2" />
      <Input
        type="search"
        placeholder={resolvedPlaceholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 pl-8"
      />
    </div>
  );
}
